module.exports = __webpack_public_path__ + "static/media/help.786ccb54.svg";